import listFilter from "../src/components/filter/listFilter.vue";
import barDiagram from "../src/components/echart/BarDiagram.vue"
import lineChart from "../src/components/echart/LineChart.vue"
import mapScatter from "../src/components/echart/MapScatter.vue"
import instrumentPanel from "../src/components/echart/InstrumentPanel.vue"
import graph from "../src/components/echart/Graph.vue"
import doughnut from "../src/components/echart/Doughnut.vue"
import progressChart from "../src/components/echart/Progress.vue"
import popup from "../src/components/common/pop-up.vue"
import heatMap from "../src/components/echart/heatMap.vue"
import pie from "../src/components/echart/pie.vue"
const components = {
    listFilter, //列表搜索组件
    barDiagram, //条形图组件
    lineChart, //折线图组件
    mapScatter, //中国地图组件(需要根据业务进行修改)
    instrumentPanel, //仪盘图
    graph, //曲线图
    doughnut, //环形图
    progressChart, //进度图
    popup,
    heatMap, //热力图
    pie, //饼状图
}
const install = function(Vue, opts = {}) {
    for (let k in components) {
        Vue.component(k, components[k]);
    }
};
export default install;